export const LOCALES = ["ar", "en"] as const;

export interface PageMeta {
  title: string;
  description: string;
  ogLocale: string;
}

export const pageMeta: Record<"landing" | "thankYou", Record<"ar" | "en", PageMeta>> = {
  landing: {
    ar: {
      title: "واجهة قرطبة | سجّل اهتمامك بمكاتب طريق المطار",
      description:
        "مكاتب للإيجار في واجهة قرطبة على طريق المطار بالرياض. سجّل اهتمامك وسيتواصل معك فريق المشروع بالمساحات المتاحة وتفاصيل التأجير.",
      ogLocale: "ar_SA",
    },
    en: {
      title: "Qurtuba Front | Register Your Interest in Offices on Airport Road",
      description:
        "Offices for lease at Qurtuba Front on Airport Road, Riyadh. Register your interest and the project team will contact you with available spaces and leasing details.",
      ogLocale: "en_US",
    },
  },
  thankYou: {
    ar: {
      title: "تم تسجيل اهتمامك بنجاح | واجهة قرطبة",
      description:
        "شكرًا لاهتمامك بواجهة قرطبة. سيتواصل معك فريقنا لتزويدك بالمساحات المتاحة وتفاصيل التأجير.",
      ogLocale: "ar_SA",
    },
    en: {
      title: "Thank you for your interest | Qurtuba Front",
      description:
        "We've received your enquiry about Qurtuba Front. Our team will contact you with leasing details.",
      ogLocale: "en_US",
    },
  },
};

export type Locale = (typeof LOCALES)[number];

export const paths = {
  ar: { home: "/", thankYou: "/thank-you" },
  en: { home: "/en", thankYou: "/en/thank-you" },
} as const;

export function localeFromPath(pathname: string): Locale {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "ar";
}

export function dir(locale: Locale): "rtl" | "ltr" {
  return locale === "ar" ? "rtl" : "ltr";
}
